export default {
  title: "Cost",
  no_cost: "No cost added yet",
  linehaul_cost: "Linehaul cost",
  total: "Total",
  edit: "Edit",
  insert_cost: "Insert cost",
};
